import styled from "styled-components";

const Img = styled.img`
  height: ${({ height }) => height};
  margin: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};
  width: ${({ width }) => width};
  &.pointer {
    cursor: pointer;
  }
`;

const Svg = styled.svg`
  color: ${({ theme, dynamic }) =>
    dynamic ? theme.tenantAccent : theme.colors.darkBlue};
`;

export { Img, Svg };
